import {
  SupplyReturnBehaviorInternal,
  MeasurementChannelKind,
  AmpTransformersInternal,
  MeterPurposeInternal,
  TimeZoneKindInternal,
  SourceThresholdInternal,
  ControlModeInternal,
  GenericInputTypeInternal,
  GenericInputMonostableModeInternal,
  GenericInputBistableModeInternal,
  OptimizerModeInternal,
  InputTriggerInternal,
  BinarySensorTypeInternal,
} from '../../../data-access/gql-types/graphql';
import {
  SupplyReturnBehaviorInternal as SupplyReturnBehaviorInternalRest,
  MeasurementChannelKind as MeasurementChannelKindRest,
  AmpTransformersInternal as AmpTransformersInternalRest,
  MeterPurposeInternal as MeterPurposeInternalRest,
  TimeZoneKindInternal as TimeZoneKindInternalRest,
  SourceThresholdInternal as SourceThresholdInternalRest,
  ControlModeInternal as ControlModeInternalRest,
  GenericInputTypeInternal as GenericInputTypeInternalRest,
  GenericInputMonostableModeInternal as GenericInputMonostableModeInternalRest,
  GenericInputBistableModeInternal as GenericInputBistableModeInternalRest,
  OptimizerModeInternal as OptimizerModeInternalRest,
  InputTriggerInternal as InputTriggerInternalRest,
  BinarySensorTypeInternal as BinarySensorTypeInternalRest,
} from './openapi/openapi-types';

export const SupplyReturnBehaviorRequest: Record<SupplyReturnBehaviorInternal, SupplyReturnBehaviorInternalRest> = {
  [SupplyReturnBehaviorInternal.AlwaysOff]: 0,
  [SupplyReturnBehaviorInternal.AlwaysOn]: 1,
  [SupplyReturnBehaviorInternal.KeepState]: 2,
};

export const MeasurementChannelKindRequest: Record<MeasurementChannelKind, MeasurementChannelKindRest> = {
  [MeasurementChannelKind.Unknown]: 0,
  [MeasurementChannelKind.Meter]: 1,
  [MeasurementChannelKind.Optimizer]: 2,
};

export const AmpTransformersInternalRequest: Record<AmpTransformersInternal, AmpTransformersInternalRest> = {
  [AmpTransformersInternal.Unknown]: 0,
  [AmpTransformersInternal.OneHundredAmps]: 1,
  [AmpTransformersInternal.TwoHundredsAmps]: 2,
  [AmpTransformersInternal.FourHundredsAmps]: 3,
  [AmpTransformersInternal.OneThousandAmps]: 4,
};

export const MeterPurposeInternalRequest: Record<MeterPurposeInternal, MeterPurposeInternalRest> = {
  [MeterPurposeInternal.Unknown]: 0,
  [MeterPurposeInternal.Main]: 1,
  [MeterPurposeInternal.Pv]: 2,
  [MeterPurposeInternal.EnergyStorage]: 3,
  [MeterPurposeInternal.Consumption]: 4,
};

export const TimeZoneKindInternalRequest: Record<TimeZoneKindInternal, TimeZoneKindInternalRest> = {
  [TimeZoneKindInternal.Unknown]: 0,
  [TimeZoneKindInternal.Summer]: 1,
  [TimeZoneKindInternal.Winter]: 2,
  [TimeZoneKindInternal.All]: 3,
};

export const ControlModeInternalRequest: Record<ControlModeInternal, ControlModeInternalRest> = {
  [ControlModeInternal.Unknown]: 0,
  [ControlModeInternal.Threshold]: 1,
  [ControlModeInternal.DynamicPrice]: 2,
};

export const SourceThresholdInternalRequest: Record<SourceThresholdInternal, SourceThresholdInternalRest> = {
  [SourceThresholdInternal.Unknown]: 0,
  [SourceThresholdInternal.Voltage]: 1,
  [SourceThresholdInternal.Current]: 2,
  [SourceThresholdInternal.ActivePower]: 3,
  [SourceThresholdInternal.BalancedPower]: 4,
  [SourceThresholdInternal.ReactivePower]: 5,
  [SourceThresholdInternal.ApparentPower]: 6,
  [SourceThresholdInternal.PhaseAngle]: 7,
  [SourceThresholdInternal.PowerFactor]: 8,
  [SourceThresholdInternal.Frequency]: 9,
};

export const GenericInputTypeInternalRequest: Record<GenericInputTypeInternal, GenericInputTypeInternalRest> = {
  [GenericInputTypeInternal.Unknown]: 0,
  [GenericInputTypeInternal.Monostable]: 1,
  [GenericInputTypeInternal.Bistable]: 2,
};

export const GenericInputMonostableModeInternalRequest: Record<
  GenericInputMonostableModeInternal,
  GenericInputMonostableModeInternalRest
> = {
  [GenericInputMonostableModeInternal.Normal]: 0,
  [GenericInputMonostableModeInternal.Reversed]: 1,
};

export const GenericInputBistableModeInternalRequest: Record<
  GenericInputBistableModeInternal,
  GenericInputBistableModeInternalRest
> = {
  [GenericInputBistableModeInternal.Normal]: 0,
  [GenericInputBistableModeInternal.TwoWay]: 1,
};

export const OptimizerModeInternalRequest: Record<OptimizerModeInternal, OptimizerModeInternalRest> = {
  [OptimizerModeInternal.Unknown]: 0,
  [OptimizerModeInternal.TestMode]: 1,
  [OptimizerModeInternal.Eco]: 2,
  [OptimizerModeInternal.Comfort]: 3,
  [OptimizerModeInternal.FullSelfConsumption]: 4,
  [OptimizerModeInternal.SelfConsumptionWithPowerLimit]: 5,
  [OptimizerModeInternal.SelfConsumptionWithRelays]: 6,
};

export const InputTriggerInternalRequest: Record<InputTriggerInternal, InputTriggerInternalRest> = {
  [InputTriggerInternal.SingleClick]: 0,
  [InputTriggerInternal.DoubleClick]: 1,
};

export const BinarySensorTypeRequest: Record<BinarySensorTypeInternal, BinarySensorTypeInternalRest> = {
  [BinarySensorTypeInternal.Unknown]: 0,
  [BinarySensorTypeInternal.Input]: 1,
  [BinarySensorTypeInternal.Movement]: 2,
  [BinarySensorTypeInternal.Flood]: 3,
  [BinarySensorTypeInternal.ReedSwitch]: 4,
};